import type { QuestionnaireAnswer } from '@gba/questionnaire-antd';

const ANSWER_TYPE = {
  Boolean: 1,
  Number: 2,
  MultiChoice: 4,
  Image: 5,
} as const;

const parseArray = (value: string): unknown[] => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const fromAnswerValue = ({ answerValue, answerType }: QuestionnaireAnswer) => {
  switch (answerType) {
    case ANSWER_TYPE.Boolean:
      return answerValue === 'true';
    case ANSWER_TYPE.Number:
      return answerValue === '' ? undefined : Number(answerValue);
    case ANSWER_TYPE.MultiChoice:
    case ANSWER_TYPE.Image:
      return parseArray(answerValue);
    default:
      return answerValue;
  }
};

export const answersToValues = (
  answers: QuestionnaireAnswer[],
): Record<string, unknown> =>
  answers.reduce<Record<string, unknown>>((values, answer) => {
    values[answer.questionKey] = fromAnswerValue(answer);
    return values;
  }, {});
